


import { captureExceptions } from 'utils/SentryHelpers'
import ManageTagsList from './ManageTagsList'
import TagTypeEnum from 'constants/TagTypeEnum'

import 'styles/components/settings/tags/ManageTags.styl'

const ManageTags = React.createClass({
  getInitialState() {
    return {}
  },

  render() {
    const filteredConversationTagsList = this.props.conversationTagList.filter(
      tag => tag.status === 'ENABLED',
    )
    const filteredCustomerTagsList = this.props.customerTagList.filter(
      tag => tag.status === 'ENABLED',
    )
    return (
      <div className="ManageTags">
        <p>
          Tags organize your inboxes and customer base. Use tags to help visualize who you are helping and what you are helping them with.
        </p>
        <div className="tag-sections">
          <div className="section">
            <div className="section-header">
              <div className="tag-section-title">
                Customer Tags
              </div>
            </div>
            <ManageTagsList
              app={this.app}
              className="customer-tag-list"
              tagType={TagTypeEnum.ANY.key}
              tagList={filteredCustomerTagsList} />
          </div>
          <div className="section">
            <div className="section-header">
              <div className="tag-section-title">
                Conversation Tags
              </div>
            </div>
            <ManageTagsList
              app={this.app}
              className="conversation-tag-list"
              tagList={filteredConversationTagsList}
              tagType={TagTypeEnum.CONVERSATION.key} />
          </div>
        </div>
      </div>
    )
  },
})

const ManageTagsContainer = Marty.createContainer(ManageTags, {
  listenTo: ['stores.TagStore'],

  fetch: {
    customerTagList() {
      return this.app.stores.TagStore.getOrFetchCustomerTagList()
    },

    conversationTagList() {
      return this.app.stores.TagStore.getOrFetchConversationTagList()
    },
  },
  pending() {
    return <div className="loader-rotating" />
  },
  failed(errors) {
    captureExceptions(errors)
    return <div />
  },
})

export default ManageTagsContainer



// WEBPACK FOOTER //
// ./src/scripts/components/settings/tags/ManageTags.js